import { createSlice } from '@reduxjs/toolkit';

const loginSlice = createSlice({
  name: 'login',
  initialState: null,
  reducers: {
    setLoginData: (state, action) => {
      state = action.payload;
      return state;
    },
    clearLogin: (state) => {
      state = null;

      return state;
    },
  },
});

export const { setLoginData, clearLogin } = loginSlice.actions;
export default loginSlice.reducer;
